import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  Companion_getInstancel4ymxmn2l08f as Companion_getInstance,
  HttpMethod__toString_impl_hhk5hkow7sfhij4zpj as HttpMethod__toString_impl_hhk5hk,
} from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/HttpMethod.mjs';
import {
  get_kiteUi2m7u81n0o8zpz as get_kiteUi,
  typed22kjp7k0ibsl8 as typed,
  toSharedFlow13chr9mav6h4g as toSharedFlow,
} from './adapt.mjs';
import { StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import {
  serializer1x79l67jvwntn as serializer,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  serializer1cdzkc3mnhoc4 as serializer_0,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instance2hzkjum14cylm as Companion_instance,
  BulkResponsenhuw5ggnccvl as BulkResponse,
  BulkRequest1ynbxhwj3d4b2 as BulkRequest,
} from '../../../../../lightning-server-typed-shared/com/lightningkite/lightningserver/typed/models.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RequestBodyTextpvofjwd95b3y as RequestBodyText,
  webSockettc1n59zaskoq as webSocket,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { connectivityFetch17pa0p5vdf435 as connectivityFetch } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch-connectivity.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer_1 } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance_0,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { delay2kng7ucb3aj62 as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { httpHeaders1p0c4h1mvk3o7 as httpHeaders } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  substringAfter35b3qhto7hchb as substringAfter,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter_0,
  split3d3yeauc4rm2n as split,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  toList3jhuyej2anx2q as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { take9j4462mea726 as take } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  report1vfr9zf0i9d9p as report,
  get_debugMode2ku08uo1anfv as get_debugMode,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { StringArrayFormat1xi667mcf8p4h as StringArrayFormat } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringArrayFormat.mjs';
import { retryWebSocket1zhkddxzq5149 as retryWebSocket } from '../../../../../kiteui-library/com/lightningkite/kiteui/wsretry.mjs';
import {
  Companion_getInstance1p6qahlqkjguh as Companion_getInstance_1,
  LSError2xrpo13ez2d1 as LSError,
  MultiplexMessaged6a8e6rgamj7 as MultiplexMessage,
} from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/LSError.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance_2 } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../LsErrorException.mjs';
import {
  get_isActivehakov5bm97hw as get_isActive,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { invokeAllSafeMutable13vuy5ase10ma as invokeAllSafeMutable } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_START_ACK_TIMEOUT() {
  _init_properties_BulkFetcher_kt__ivq43n();
  return START_ACK_TIMEOUT;
}
var START_ACK_TIMEOUT;
function *fetch($this, $completion) {
  var todo = $this.fetchQueue_1;
  $this.fetchQueue_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
  $this.scheduled_1 = false;
  try {
    var tmp = get_kiteUi(Companion_getInstance().POST_1);
    var tmp_0 = BulkFetcher$fetch$slambda($this);
    var tmp_1 = MapSerializer(serializer(StringCompanionObject_instance), Companion_instance.serializer_9w0wvi_k$());
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(mapCapacity(todo.get_size_woubt6_k$()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = todo.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp_2 = element.get_key_18j28a_k$();
      var tmp$ret$4 = element.get_value_j01efc_k$().first_1;
      destination.put_4fpzoq_k$(tmp_2, tmp$ret$4);
    }
    // Inline function 'kotlin.let' call
    var it = yield* connectivityFetch($this.httpBulk_1, tmp, tmp_0, new (RequestBodyText())($this.json_1.encodeToString_k0apqx_k$(tmp_1, destination), 'application/json'), $completion);
    if (!it.get_ok_kntnrv_k$()) {
      var failed = Exception().new_kotlin_Exception_hsqbop_k$(it.get_status_jnf6d7_k$().toString() + ': ' + (yield* it.text_7k3n3e_k$($completion)));
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = todo.get_values_ksazhn_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = element_0.second_1;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$10 = _Result___init__impl__xyqfz8(createFailure(failed));
        this_0.resumeWith_rk9gbt_k$(tmp$ret$10);
      }
    } else {
      var tmp0 = $this.json_1;
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var string = yield* it.text_7k3n3e_k$($completion);
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = tmp0.get_serializersModule_piitvg_k$();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer_1(this_1, createKType(getKClass(KtMap()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(BulkResponse()), arrayOf([]), false))]), false));
      var tmp$ret$12 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
      var responses = tmp0.decodeFromString_jwu9sq_k$(tmp$ret$12, string);
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = todo.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
        var tmp0_safe_receiver = responses.get_wei43m_k$(element_1.get_key_18j28a_k$());
        var tmp_3;
        if (tmp0_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.coroutines.resume' call
          var this_3 = element_1.get_value_j01efc_k$().second_1;
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$20 = _Result___init__impl__xyqfz8(tmp0_safe_receiver);
          this_3.resumeWith_rk9gbt_k$(tmp$ret$20);
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          var tmp0_0 = element_1.get_value_j01efc_k$().second_1;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = Exception().new_kotlin_Exception_hsqbop_k$('Bulk key ' + element_1.get_key_18j28a_k$() + ' not found');
          var tmp$ret$22 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0_0.resumeWith_rk9gbt_k$(tmp$ret$22);
        }
      }
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = todo.get_values_ksazhn_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
        var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_4 = element_2.second_1;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$26 = _Result___init__impl__xyqfz8(createFailure(e));
        this_4.resumeWith_rk9gbt_k$(tmp$ret$26);
      }
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function typedWithDebug($this, $receiver, json, send, receive, log) {
  log = log === VOID ? null : log;
  return new (BulkFetcher$typedWithDebug$1())($receiver, log, json, receive, send);
}
function BulkFetcher$_init_$slambda_5xatx3() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }), 0);
}
function BulkFetcher$invoke$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay(this$0.delay_1, $completion);
    yield* /*#__NOINLINE__*/fetch(this$0, $completion);
    return Unit_instance;
  }), 1);
}
function BulkFetcher$fetch$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return httpHeaders(yield* $(this$0.calculator_1($completion), $completion));
  }), 0);
}
function BulkFetcher$wsMuxer$slambda$lambda(it) {
  return it.first_1 + '=' + it.second_1;
}
function BulkFetcher$wsMuxer$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var headers = yield* $(this$0.calculator_1($completion), $completion);
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!headers.isEmpty_y1axqb_k$()) {
      var terminator = contains(this$0.wsMultiplex_1, _Char___init__impl__6a9atx(63)) ? _Char___init__impl__6a9atx(38) : _Char___init__impl__6a9atx(63);
      var tmp_0 = toString(terminator);
      tmp = this$0.wsMultiplex_1 + (tmp_0 + joinToString(headers, '&', VOID, VOID, VOID, VOID, BulkFetcher$wsMuxer$slambda$lambda));
    } else {
      tmp = this$0.wsMultiplex_1;
    }
    var url = tmp;
    return webSocket(url);
  }), 0);
}
var BulkFetcher$typedWithDebug$1Class;
function BulkFetcher$typedWithDebug$1() {
  if (BulkFetcher$typedWithDebug$1Class === VOID) {
    class $ {
      constructor($this_typedWithDebug, $log, $json, $receive, $send) {
        this.$this_typedWithDebug_1 = $this_typedWithDebug;
        this.$log_1 = $log;
        this.$json_1 = $json;
        this.$receive_1 = $receive;
        this.$send_1 = $send;
      }
      get_connected_12bogw_k$() {
        return this.$this_typedWithDebug_1.get_connected_12bogw_k$();
      }
      beginUse_omrbby_k$() {
        return this.$this_typedWithDebug_1.beginUse_omrbby_k$();
      }
      close_a2oca2_k$(code, reason) {
        return this.$this_typedWithDebug_1.close_a2oca2_k$(code, reason);
      }
      onOpen_i39mgf_k$(action) {
        return this.$this_typedWithDebug_1.onOpen_i39mgf_k$(action);
      }
      onClose_nz13c7_k$(action) {
        return this.$this_typedWithDebug_1.onClose_nz13c7_k$(action);
      }
      onMessage_68111k_k$(action) {
        this.$this_typedWithDebug_1.onMessage_u48dtp_k$((it) => {
          var tmp;
          if (!(this.$log_1 == null) && startsWith(it, '!!! DEBUG AWS INFO !!! - ')) {
            this.$log_1.log_iyb52q_k$(['AWS: ' + substringAfter(it, '!!! DEBUG AWS INFO !!! - ')]);
            return Unit_instance;
          }
          var tmp_0;
          try {
            tmp_0 = action(this.$json_1.decodeFromString_jwu9sq_k$(this.$receive_1, it));
          } catch ($p) {
            var tmp_1;
            if ($p instanceof CancellationException()) {
              var e = $p;
              tmp_1 = Unit_instance;
            } else {
              if ($p instanceof Exception()) {
                var e_0 = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to decode message; expected a ' + this.$receive_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + " but got '" + take(it, 150) + "'", e_0));
                tmp_1 = Unit_instance;
              } else {
                throw $p;
              }
            }
            tmp_0 = tmp_1;
          }
          return Unit_instance;
        });
      }
      send_lirmaz_k$(data) {
        this.$this_typedWithDebug_1.send_oy6aea_k$(this.$json_1.encodeToString_k0apqx_k$(this.$send_1, data));
      }
    }
    initMetadataForClass($);
    BulkFetcher$typedWithDebug$1Class = $;
  }
  return BulkFetcher$typedWithDebug$1Class;
}
var BulkFetcherClass;
function BulkFetcher() {
  if (BulkFetcherClass === VOID) {
    class $ {
      constructor(httpBulk, wsMultiplex, json, pingTime, delay, log, calculator) {
        json = json === VOID ? get_DefaultJson() : json;
        var tmp;
        if (pingTime === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_0();
          tmp = toDuration(5000, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = pingTime;
        }
        pingTime = tmp;
        var tmp_0;
        if (delay === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_0();
          tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp_0 = delay;
        }
        delay = tmp_0;
        log = log === VOID ? null : log;
        var tmp_1;
        if (calculator === VOID) {
          tmp_1 = BulkFetcher$_init_$slambda_5xatx3();
        } else {
          tmp_1 = calculator;
        }
        calculator = tmp_1;
        this.httpBulk_1 = httpBulk;
        this.wsMultiplex_1 = wsMultiplex;
        this.json_1 = json;
        this.pingTime_1 = pingTime;
        this.delay_1 = delay;
        this.log_1 = log;
        this.calculator_1 = calculator;
        this.stringArrayFormat_1 = new (StringArrayFormat())(this.json_1.get_serializersModule_piitvg_k$());
        this.fetchQueue_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.scheduled_1 = false;
        var tmp_2 = this;
        tmp_2.wsMuxer_1 = typedWithDebug(this, retryWebSocket(BulkFetcher$wsMuxer$slambda(this), _Duration___get_inWholeMilliseconds__impl__msfiry(this.pingTime_1), VOID, this.log_1), this.json_1, Companion_getInstance_1().serializer_9w0wvi_k$(), Companion_getInstance_1().serializer_9w0wvi_k$());
        this.multiplexed_1 = new (MultiplexedSocket())(this.wsMuxer_1, this.log_1);
      }
      url_tsvlb2_k$(value, serializer) {
        return this.stringArrayFormat_1.encodeToString_k0apqx_k$(serializer, value);
      }
      withHeaderCalculator_vab9hb_k$(calculator) {
        return new (BulkFetcher())(this.httpBulk_1, this.wsMultiplex_1, this.json_1, this.pingTime_1, this.delay_1, this.log_1, calculator);
      }
      *invoke_vgogw6_k$(url, method, inSerializer, body, outSerializer, $completion) {
        var id = Companion_getInstance_2().random_fimq0t_k$().toString();
        var req = new (BulkRequest())(url, HttpMethod__toString_impl_hhk5hk(method), inSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === 'kotlin.Unit' ? null : this.json_1.encodeToString_k0apqx_k$(inSerializer, body));
        if (!this.scheduled_1) {
          this.scheduled_1 = true;
          var tmp = get_AppScope();
          launch(tmp, VOID, VOID, BulkFetcher$invoke$slambda(this));
        }
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        // Inline function 'kotlin.let' call
        var it = yield () => {
          var uCont = $completion;
          var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
          cancellable.initCancellability_shqc60_k$();
          var tmp0 = this.fetchQueue_1;
          var tmp2 = id;
          // Inline function 'kotlin.collections.set' call
          var value = to(req, cancellable);
          tmp0.put_4fpzoq_k$(tmp2, value);
          return cancellable.getResult_fck196_k$();
        };
        var tmp_0;
        if (it.error_1 == null && outSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === serializer_0(Unit_instance).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$()) {
          tmp_0 = Unit_instance;
        } else if (!(it.result_1 == null)) {
          tmp_0 = this.json_1.decodeFromString_jwu9sq_k$(outSerializer, ensureNotNull(it.result_1));
        } else {
          var tmp0_elvis_lhs = it.error_1;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            var tmp1_safe_receiver = it.error_1;
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.http_1;
            tmp_1 = new (LSError())(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          throw LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(tmp_1);
        }
        return tmp_0;
      }
      webSocket_nkn44m_k$(url, inSerializer, outSerializer) {
        return typed(this.multiplexed_1.channel_cghzs9_k$(url), this.json_1, inSerializer, outSerializer);
      }
    }
    initMetadataForClass($, 'BulkFetcher', VOID, VOID, VOID, [5, 0]);
    BulkFetcherClass = $;
  }
  return BulkFetcherClass;
}
function requestStart($this) {
  var tmp0_safe_receiver = $this.opening_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.cancel$default_8haxne_k$();
  }
  var tmp = $this;
  tmp.opening_1 = launch($this.lifecycle_1, VOID, VOID, MultiplexedSocket$WebSocketChannel$requestStart$slambda($this, $this.$this_1));
}
function MultiplexedSocket$WebSocketChannel$requestStart$slambda(this$0, this$1) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    while (get_isActive($this$launch) && this$0.shouldBeOn_1.get_value_j01efc_k$() && ReactiveState__getOrNull_impl_1asnfp(this$1.muxer_1.get_connected_12bogw_k$().get_state_wc71uu_k$()) === true && !this$0.connectedSignal_1.get_value_j01efc_k$()) {
      var tmp0_safe_receiver = this$1.log_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.log_iyb52q_k$(['Requesting channel ' + this$0.channel_1 + ' for ' + this$0.path_1]);
      }
      this$1.muxer_1.send_lirmaz_k$(new (MultiplexMessage())(this$0.channel_1, this$0.path_1, this$0.params_1, true));
      yield* delay(get_START_ACK_TIMEOUT(), $completion);
    }
    return Unit_instance;
  }), 1);
}
var WebSocketChannelClass;
function WebSocketChannel() {
  if (WebSocketChannelClass === VOID) {
    class $ {
      constructor($outer, url) {
        this.$this_1 = $outer;
        this.path_1 = substringBefore(url, _Char___init__impl__6a9atx(63));
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = split(substringAfter_0(url, _Char___init__impl__6a9atx(63), ''), charArrayOf([_Char___init__impl__6a9atx(38)]));
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = to(substringBefore(item, _Char___init__impl__6a9atx(61)), substringAfter_0(item, _Char___init__impl__6a9atx(61)));
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        // Inline function 'kotlin.collections.groupBy' call
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var key = element.first_1;
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination_0.get_wei43m_k$(key);
          var tmp_0;
          if (value == null) {
            var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            destination_0.put_4fpzoq_k$(key, answer);
            tmp_0 = answer;
          } else {
            tmp_0 = value;
          }
          var list = tmp_0;
          var tmp$ret$8 = element.second_1;
          list.add_utx5q5_k$(tmp$ret$8);
        }
        tmp.params_1 = destination_0;
        this.connectedSignal_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.connected_1 = toSharedFlow(this.connectedSignal_1);
        this.channel_1 = Companion_getInstance_2().random_fimq0t_k$().toString();
        this.shouldBeOn_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.closeChannel_1 = null;
        var tmp_1 = this;
        // Inline function 'kotlin.apply' call
        var this_1 = CoroutineScope(Job());
        reactiveScope(this_1, ($this$reactiveScope) => {
          var shouldBeOn = $this$reactiveScope.invoke_r7m7el_k$(this.shouldBeOn_1);
          var isOn = $this$reactiveScope.invoke_r7m7el_k$(this.connectedSignal_1);
          var parentConnected = $this$reactiveScope.invoke_r7m7el_k$(this.$this_1.muxer_1.get_connected_12bogw_k$());
          var tmp;
          if (shouldBeOn && parentConnected && !isOn) {
            requestStart(this);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        tmp_1.lifecycle_1 = this_1;
        this.opening_1 = null;
        this.onOpenList_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.onMessageList_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.onCloseList_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      handleMessage_fmzvla_k$(message) {
        if (message.start_1) {
          var tmp0_safe_receiver = this.opening_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.cancel$default_8haxne_k$();
          }
          this.opening_1 = null;
          this.connectedSignal_1.set_value_v1vabv_k$(true);
          invokeAllSafeMutable(this.onOpenList_1);
        }
        var tmp1_safe_receiver = message.data_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = toList(this.onMessageList_1).iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            element(tmp1_safe_receiver);
          }
        }
        if (message.end_1) {
          this.connectedSignal_1.set_value_v1vabv_k$(false);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_0 = toList(this.onCloseList_1).iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
            element_0(-1);
          }
        }
      }
      handleParentClose_4g3wpi_k$() {
        this.connectedSignal_1.set_value_v1vabv_k$(false);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = toList(this.onCloseList_1).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          element(-1);
        }
      }
      connect_ivqcka_k$() {
        this.shouldBeOn_1.set_value_v1vabv_k$(true);
        var tmp0 = this.$this_1.channels_1;
        // Inline function 'kotlin.collections.set' call
        var key = this.channel_1;
        tmp0.put_4fpzoq_k$(key, this);
        if (this.closeChannel_1 == null)
          this.closeChannel_1 = this.$this_1.muxer_1.beginUse_omrbby_k$();
      }
      close_a2oca2_k$(code, reason) {
        if (!this.shouldBeOn_1.get_value_j01efc_k$())
          return Unit_instance;
        this.shouldBeOn_1.set_value_v1vabv_k$(false);
        this.$this_1.muxer_1.send_lirmaz_k$(new (MultiplexMessage())(this.channel_1, this.path_1, this.params_1, VOID, true));
        this.connectedSignal_1.set_value_v1vabv_k$(false);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = toList(this.onCloseList_1).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          element(-1);
        }
        this.$this_1.channels_1.remove_gppy8k_k$(this.channel_1);
        var tmp0_safe_receiver = this.closeChannel_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.closeChannel_1 = null;
        var tmp1_safe_receiver = this.opening_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.cancel$default_8haxne_k$();
        }
        this.opening_1 = null;
      }
      send_oy6aea_k$(data) {
        this.$this_1.muxer_1.send_lirmaz_k$(new (MultiplexMessage())(this.channel_1, VOID, VOID, VOID, VOID, data));
      }
      send_lirmaz_k$(data) {
        return this.send_oy6aea_k$((!(data == null) ? typeof data === 'string' : false) ? data : THROW_CCE());
      }
      onOpen_i39mgf_k$(action) {
        this.onOpenList_1.add_utx5q5_k$(action);
      }
      onMessage_u48dtp_k$(action) {
        this.onMessageList_1.add_utx5q5_k$(action);
      }
      onMessage_68111k_k$(action) {
        return this.onMessage_u48dtp_k$(action);
      }
      onClose_nz13c7_k$(action) {
        this.onCloseList_1.add_utx5q5_k$(action);
      }
    }
    initMetadataForClass($, 'WebSocketChannel');
    WebSocketChannelClass = $;
  }
  return WebSocketChannelClass;
}
var MultiplexedSocketClass;
function MultiplexedSocket() {
  if (MultiplexedSocketClass === VOID) {
    class $ {
      constructor(muxer, log) {
        log = log === VOID ? null : log;
        this.muxer_1 = muxer;
        this.log_1 = log;
        this.channels_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        if (get_debugMode() && !(this.log_1 == null)) {
          this.muxer_1.onOpen_i39mgf_k$(() => {
            this.muxer_1.send_lirmaz_k$(new (MultiplexMessage())('debug', VOID, VOID, true));
            return Unit_instance;
          });
        }
        this.muxer_1.onMessage_68111k_k$((message) => {
          var tmp;
          if (!(this.log_1 == null) && message.channel_1 === 'debug') {
            this.log_1.log_iyb52q_k$(['Multiplex debug: ' + message.toString()]);
            tmp = Unit_instance;
          }
          var tmp0_safe_receiver = this.channels_1.get_wei43m_k$(message.channel_1);
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.handleMessage_fmzvla_k$(message);
          }
          return Unit_instance;
        });
        this.muxer_1.onClose_nz13c7_k$((it) => {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = toList(this.channels_1.get_values_ksazhn_k$()).iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            element.handleParentClose_4g3wpi_k$();
          }
          return Unit_instance;
        });
      }
      channel_cghzs9_k$(url) {
        return new (WebSocketChannel())(this, url);
      }
    }
    initMetadataForClass($, 'MultiplexedSocket');
    MultiplexedSocketClass = $;
  }
  return MultiplexedSocketClass;
}
var properties_initialized_BulkFetcher_kt_3tvpmj;
function _init_properties_BulkFetcher_kt__ivq43n() {
  if (!properties_initialized_BulkFetcher_kt_3tvpmj) {
    properties_initialized_BulkFetcher_kt_3tvpmj = true;
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_0();
    START_ACK_TIMEOUT = toDuration(4, DurationUnit_SECONDS_getInstance());
  }
}
//region block: exports
export {
  BulkFetcher as BulkFetcher2m111bjvjns8,
};
//endregion

//# sourceMappingURL=BulkFetcher.mjs.map
